import { type ForwardedRef, forwardRef, useMemo } from 'react';

import { JobHistoryType } from '@/common/graphql';
import { JobHistoryTypeLabels } from '@/common/types';
import { ObjectUtils } from '@/common/utils';

import type { ComboboxItemWithFormatted } from '../props';
import { SelectSingle, type SelectSingleProps } from '../SelectSingle';

interface JobHistoryTypeSelectSingleProps
  extends Omit<SelectSingleProps<ComboboxItemWithFormatted<JobHistoryType>>, 'searchable' | 'value'> {
  isFirstRecord?: boolean;
  value: JobHistoryType | null;
}

export const JobHistoryTypeSelectSingle = forwardRef(
  (
    { isFirstRecord, placeholder = 'Select Type', value, ...rest }: JobHistoryTypeSelectSingleProps,
    ref: ForwardedRef<HTMLDivElement>,
  ) => {
    const data = useMemo(
      () =>
        ObjectUtils.arrayFromEnumValues<JobHistoryType>(JobHistoryType)
          .map(value => ({ label: JobHistoryTypeLabels[value], value }) as ComboboxItemWithFormatted<JobHistoryType>)
          // Hide Join if at least one record exists, but show if the current record is Join
          .filter(type => (value === JobHistoryType.Join || isFirstRecord ? true : type.value !== JobHistoryType.Join)),
      [isFirstRecord, value],
    );

    return (
      <SelectSingle
        ref={ref}
        {...rest}
        data={data}
        loading={false}
        placeholder={placeholder}
        searchable={false}
        value={value}
      />
    );
  },
);
